/**
 * Returns the localized listing page paths for 3d-models and 3d-print-models
 * based on the provided locale segment.
 *
 * @param {string|null|undefined} localeSegment - The locale segment from the URL path (e.g., 'de', 'es', 'fr')
 * @returns {{ modelsPath: string, printModelsPath: string }} - Object containing the localized paths
 */
export function getListingPagePaths(localeSegment) {
  const locale3DModelPaths = {
    de: '3d-modelle',
    es: '3d-modelos',
    fr: '3d-modeles',
    pt: '3d-modelos',
    ru: '3d-modeli',
    ja: '3d-models',
    'zh-cn': '3d-models',
  }

  const locale3DPrintModelPaths = {
    de: '3d-druck-modelle',
    es: '3d-de-impresion-modelos',
    fr: '3d-imprimer-modeles',
    pt: '3d-impressao-modelos',
    ru: '3d-pechat-modeli',
    ja: '3d-print-models',
    'zh-cn': '3d-print-models',
  }

  const lowerCasedLocaleSegment = localeSegment?.toLowerCase()
  const localePrefixes = ['de', 'es', 'fr', 'pt', 'ru', 'ja', 'zh-cn']
  const hasLocalePrefix = localeSegment && localePrefixes.includes(lowerCasedLocaleSegment)

  return {
    modelsPath: hasLocalePrefix ? locale3DModelPaths[lowerCasedLocaleSegment] : '3d-models',
    printModelsPath: hasLocalePrefix
      ? locale3DPrintModelPaths[lowerCasedLocaleSegment]
      : '3d-print-models',
  }
}
